import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=104ad562"
import script from "./loading.vue?vue&type=script&lang=ts"
export * from "./loading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiContainer: require('/vercel/path0/components/ui/container.vue').default})
